// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const harvestScaleId = (z.number());
export const harvestScale = z.object({
    id: harvestScaleId,
    label: z.string(),
    harvest_letter: z.string(),
});
export const harvestScaleInitializer = z.object({
    id: harvestScaleId.optional(),
    label: z.string(),
    harvest_letter: z.string(),
});
export const harvestScaleMutator = z.object({
    id: harvestScaleId.optional(),
    label: z.string().optional(),
    harvest_letter: z.string().optional(),
});
//# sourceMappingURL=HarvestScale.js.map